import axios from 'axios'
// @ts-ignore
import tsignData from '@/lib/tsignData.ts'
// @ts-ignore
import { getTokenHeader } from '@/plugins/token'
import Vue from 'vue'

const LOGIN_EXPIRED = 401

declare const process: Process
interface Process {
  [t: string]: any
}
console.log('process.env.environment', process.env)
declare const window: any

// 全局请求配置
axios.defaults.timeout = 100000
axios.defaults.headers['x-requested-with'] = 'XMLHttpRequest'
axios.defaults.withCredentials = true
console.log('process.env.VUE_APP_MODE', process.env.VUE_APP_MODE, process.env)
if (process.env.VUE_APP_MODE === 'dev' && process.env.groupId) {
  axios.defaults.headers['X-Tsign-Service-Group'] = process.env.groupId
}

// 配置默认请求头
Object.assign(axios.defaults.headers, {
  'X-Tsign-Open-App-Id': '',
  'X-Tsign-Open-Tenant-Id': '',
  'X-Tsign-Client-Id': 'WEB',
  'X-Tsign-Client-AppName': 'web-treaty-front_2.0',
})

// 配置官网请求实例
const http: any = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
})

// 神策埋点配置
const presetProps = tsignData.getPresetProperties()

http.interceptors.request.use((req: any) => {
  const timer = Date.now()
  req.url = req.url.includes('?') ? `${req.url}&t=${timer}` : `${req.url}?t=${timer}`

  req.headers = Object.assign(
    {
      ...axios.defaults.headers,

      // eslint-disable-next-line camelcase
      _latest_tsign_source_type: presetProps['_latest_tsign_source_type'] || '',
      // eslint-disable-next-line camelcase
      _latest_tsign_source_detail: presetProps['_latest_tsign_source_detail'] || '',

      ...getTokenHeader(), // 带token的登录方式
    },
    req.headers
  )

  return req
})

http.interceptors.response.use(
  (response: any) => {
    if (response.data.code !== 0) {
      window.$skyeye && window.$skyeye.ajaxError(response)

      return Promise.reject(response.data)
    }

    // 服务器返回消息体
    return response.data
  },
  (error: any) => {
    try {
      window.$skyeye && window.$skyeye.ajaxError(error)
    } catch (e) {
      console.error('天眼配置错误', e)
    }

    // 服务端，客户端统一reject错误对象，因此页面组件asyncData，fetch函数请求api接口一定要做catch处理
    // 组件的beforeCreated, created钩子(会在node端运行)函数请求api接口也一定要做catch处理
    return Promise.reject(error)
  }
)

export default http
